
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skidort",
      function () {
        return require("private-next-pages/skidort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skidort"])
      });
    }
  